<template>
  <div class="text-collapsable">
    <div
      ref="text"
      class="text-content"
      :class="{ 'text-collapsed': is_collapsed && needs_collapse }"
      :style="{ 'max-height': is_collapsed ? max_height + 'px' : null }"
      v-html="content"
    />
    <div
      v-if="needs_collapse && !selector"
      :class="link ? 'text-start pt-0' : 'text-center pt-3'"
    >
      <a
        :class="link ? 'text-muted small' : 'btn btn-outline-light'"
        href="#"
        @click.prevent.stop="toggle()"
      >
        {{
          expanded ? translations.actions.HIDE : translations.actions.SHOW_ALL
        }}
        <icon name="ARROW_RIGHT" />
      </a>
    </div>
  </div>
</template>

<script>
import { scan } from "@pdfking/rfunc"
import icon from "@pdfking/workflow/components/icon"
import make_translations from "@pdfking/workflow/utils/make_translations"
import toggle_class from "../dom/toggle_class"
import state from "../state/main"
import persistence from "../utils/persistence"

export default {
  components: { icon },
  computed: {
    is_collapsed() {
      return !this.expanded && this.needs_collapse
    },
    translations: () => make_translations("actions"),
  },
  data() {
    const store = this.persist
      ? persistence(`collapsable-${this.persist}`)
      : null

    return {
      expanded: false,
      max_height: this.height || 300,
      needs_collapse: false,
      store,
    }
  },

  methods: {
    toggle() {
      const expanded = !this.expanded
      this.store?.set(expanded)
      this.expanded = expanded
      if (!expanded) state.track_event("button_expand", "expand")
    },
  },
  mounted() {
    this.store?.get().then(v => (this.expanded = v))

    this.$nextTick(() => {
      this.needs_collapse = this.$refs.text.clientHeight > this.max_height

      if (this.needs_collapse && this.selector)
        scan(
          el =>
            el.addEventListener("click", e => {
              e.preventDefault()
              e.stopPropagation()
              this.toggle()
            }),
          toggle_class(this.selector, {
            [this.add]: true,
            [this.remove]: false,
          })
        )
    })
  },
  props: ["content", "height", "link", "selector", "remove", "add", "persist"],
}
</script>
